<template>
	<v-form ref="f" v-model="validUpload">
		<v-container fluid>
			<v-row class="mt-6 headline"><v-col>P&L Импорт данных</v-col></v-row>

			<v-row >
				<v-col>
					<p>
						Выберите файл формата csv для загрузки данных PL. Файл не должен содержать названий столбцов. Каждая строка файла должна содержать данные в следующем формате:
					</p>

					<p class="title font-weight-light">[код отдела];[код статьи];[сумма]</p>
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12" md="6" class="">
					<v-row class="pb-0" >
						<v-col>
							<a-hotel-select
								v-model="form.hotelCode"
								:hotels="hotels"
								@change="changeHotel"
								solo>
							</a-hotel-select>
						</v-col>
					</v-row>
					<v-row class="pt-0" >
						<v-col>
							<v-checkbox
								v-model="form.ytd"
								label="Year to date">
							</v-checkbox>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<a-file-picker
								v-model="csv"
								label="Выберите файл"
								formats="csv"
								maxSize="3"
								required>
							</a-file-picker>
						</v-col>
					</v-row>
				</v-col>

				<v-col cols="12" md="6">
					<v-date-picker
						v-model="form.month"
						type="month"
						:landscape="true"
						:reactive="true"
						locale="ru-ru"
						:readonly="!!maxMonth"
						:show-current="false"
						:min="maxMonth"
						:max="minMonth"
						full-width>
					</v-date-picker>
				</v-col>
			</v-row>

			<v-row>
				<v-col>
					<v-btn
						class="ma-2"
						@click="upload"
						color="primary"
						:disabled="!validUpload">
						Загрузить
					</v-btn>
					<v-tooltip bottom max-width="300"
							   close-delay="0"
							   v-model="clearTooltipShow">
				      	<template v-slot:activator="{ on }">
							<v-btn
								class="ma-2"
								@click="clear"
								color="primary"
								:disabled="!validClear"
								v-on="on">
								Очистить
							</v-btn>
				      	</template>
				      	<span>
							Импортированные данные за выбранный период будут стерты.
							Резервы, аддоны, корректировки и данные, занесенные HOD не будут изменены.
						</span>
				    </v-tooltip>
				</v-col>
			</v-row>
		</v-container>
	</v-form>
</template>


<script>
	import aHotelSelect from '../../base/AHotelSelect.vue'
	import aFilePicker from '../../base/AFilePicker.vue'
	import {api} from '../../../lib/api'
	import {getMonthName} from '../../../js/common.js'

	export default {
		components: {
			aHotelSelect,
			aFilePicker
		},
		data: () => ({
			form: {
				hotelCode: null,
				month: '',
				ytd: false,
			},
			hotels: null,
			clearTooltipShow: false,
			validUpload: false,
			validClear: false,
			csv: []
		}),
		computed: {
			selectedHotel() {
				let index = this.hotels.map(hotel => (hotel.code || null)).indexOf(this.form.hotelCode)
				return this.hotels[index]
			},
			maxMonth() {
				if (this.selectedHotel.month) return this.selectedHotel.month
				else return undefined
			},
			minMonth() {
				if (this.selectedHotel.month) return this.selectedHotel.month
				else return undefined
			}
		},
		created() {
			if (this.$store.getters.userHo) {
				this.hotels = this.$store.getters.allHotels
			}
			else {
				this.hotels = this.$store.getters.userHotels
			}

			this.form.hotelCode = this.$store.getters.selectedHotelCode || this.hotels[0].code

			this.apiFirstCall()
		},
		methods: {
			clear() {
				api.post('pl/clear_report', this.form)
				.then(response => {

					this.$store.dispatch('dialogLoadingStop')
					this.$store.dispatch('dialogDone')

					this.validClear = false
					this.clearTooltipShow = false
					this.selectedHotel.csvReady = false

				}, error => {
					this.$store.dispatch('dialogLoadingStop')
				})
				this.$store.dispatch('dialogLoadingStart')
			},
			upload() {
				var formData = new FormData()
				formData.append('form', JSON.stringify(this.form))
				formData.append('csv', this.csv[0])

				api.post('pl/import_csv', formData)
				.then(response => {

					this.$store.dispatch('dialogLoadingStop')
					this.$store.dispatch('dialogDone')

					this.validClear = true
					this.selectedHotel.csvReady = true

				}, error => {
					this.$store.dispatch('dialogLoadingStop')
				})
				this.$store.dispatch('dialogLoadingStart')
			},
			changeHotel() {
				if (this.selectedHotel.month) this.form.month = this.selectedHotel.month
				else this.form.month = ''

				this.validClear = this.selectedHotel.csvReady
			},
			apiFirstCall() {
				api.post('pl/get_pending_report_month', {
					hotels: this.hotels,
					checkCsvReady: true
				})
				.then(response => {

					this.hotels = response.data.hotels
					this.form.hotelCode = this.$store.getters.selectedHotelCode || this.hotels[0].code
					this.changeHotel()

				}, error => {})
			}
		}
	}
</script>
